import { Outlet, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { apiFetch } from '../lib/api';

// 導航項目定義
const navItems = [
  { path: '/dashboard', icon: 'home', label: '總覽' },
  { path: '/soul', icon: 'soul', label: '靈魂' },
  { path: '/organs', icon: 'organs', label: '器官' },
  { path: '/diaries', icon: 'diary', label: '日記' },
  { path: '/chat', icon: 'chat', label: '聊天' },
  { path: '/tts-rules', icon: 'mic', label: '發音' },
  { path: '/thoughts', icon: 'brain', label: '心房' },
  { path: '/settings', icon: 'settings', label: '設定' },
];

// 圖標組件
function NavIcon({ type, isActive }: { type: string; isActive: boolean }) {
  const color = isActive ? '#e91e8c' : '#8888aa';

  switch (type) {
    case 'home':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      );
    case 'organs':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12l-5.74 9.94"/>
        </svg>
      );
    case 'diary':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
        </svg>
      );
    case 'chat':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      );
    case 'mic':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
          <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
          <line x1="12" y1="19" x2="12" y2="23"/>
          <line x1="8" y1="23" x2="16" y2="23"/>
        </svg>
      );
    case 'settings':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"/>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
      );
    case 'soul':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <circle cx="12" cy="12" r="4"/>
          <line x1="12" y1="2" x2="12" y2="4"/>
          <line x1="12" y1="20" x2="12" y2="22"/>
          <line x1="2" y1="12" x2="4" y2="12"/>
          <line x1="20" y1="12" x2="22" y2="12"/>
        </svg>
      );
    case 'brain':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2a7 7 0 0 0-7 7c0 2.5 1.3 4.8 3.5 6v3.5h7V15c2.2-1.2 3.5-3.5 3.5-6a7 7 0 0 0-7-7z"/>
          <line x1="9.5" y1="18.5" x2="14.5" y2="18.5"/>
          <line x1="10" y1="21" x2="14" y2="21"/>
        </svg>
      );
    case 'logout':
      return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
          <polyline points="16 17 21 12 16 7"/>
          <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
      );
    default:
      return null;
  }
}

// 獲取頁面標題
function getPageTitle(pathname: string): string {
  switch (pathname) {
    case '/dashboard': return '總覽';
    case '/soul': return '靈魂監控台';
    case '/organs': return '器官調控';
    case '/diaries': return '日記';
    case '/chat': return '即時聊天';
    case '/tts-rules': return '發音校正';
    case '/settings': return '系統設定';
    case '/thoughts': return '包容心房';
    default: return '包小容管理中台';
  }
}

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    await apiFetch('/api/auth/logout', { method: 'POST' });
    navigate('/welcome');
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-bg-primary">
      {/* 左側側邊欄 - 固定72px寬度的圖標欄 */}
      <aside
        className="fixed left-0 top-0 h-full z-40 hidden md:flex flex-col"
        style={{
          width: '72px',
          background: 'var(--bg-surface)',
          borderRight: '1px solid var(--border)',
        }}
      >
        {/* Logo */}
        <div
          className="flex items-center justify-center"
          style={{ height: '56px', borderBottom: '1px solid var(--border)' }}
        >
          <div
            className="relative w-9 h-9 rounded-full flex items-center justify-center animate-breathe cursor-pointer"
            style={{
              background: 'linear-gradient(135deg, rgba(233, 30, 140, 0.2), rgba(233, 30, 140, 0.05))',
            }}
            onClick={() => navigate('/dashboard')}
          >
            <div
              className="w-5 h-5 rounded-full"
              style={{
                background: 'radial-gradient(circle at 30% 30%, #ff6bb3, #e91e8c)',
                boxShadow: '0 0 15px rgba(233, 30, 140, 0.5)',
              }}
            />
          </div>
        </div>

        {/* 導航圖標 */}
        <nav className="flex-1 flex flex-col items-center pt-4 gap-2">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className="relative group"
            >
              {({ isActive }) => (
                <>
                  <div
                    className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200"
                    style={{
                      background: isActive ? 'rgba(233, 30, 140, 0.15)' : 'transparent',
                    }}
                  >
                    <NavIcon type={item.icon} isActive={isActive} />
                  </div>
                  {/* Tooltip */}
                  <div
                    className="absolute left-full top-1/2 -translate-y-1/2 ml-3 px-3 py-1.5 rounded-lg text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
                    style={{
                      background: 'var(--bg-surface-3)',
                      color: 'var(--text-primary)',
                      border: '1px solid var(--border)',
                    }}
                  >
                    {item.label}
                  </div>
                </>
              )}
            </NavLink>
          ))}
        </nav>

        {/* 底部登出按鈕 */}
        <div className="pb-4 flex flex-col items-center gap-1">
          <button
            onClick={handleLogout}
            className="w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-200 hover:bg-red/10 group relative"
          >
            <NavIcon type="logout" isActive={false} />
            {/* Tooltip */}
            <div
              className="absolute left-full top-1/2 -translate-y-1/2 ml-3 px-3 py-1.5 rounded-lg text-xs whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
              style={{
                background: 'var(--bg-surface-3)',
                color: 'var(--text-primary)',
                border: '1px solid var(--border)',
              }}
            >
              登出
            </div>
          </button>
          <span className="text-[10px]" style={{ color: 'var(--text-muted)' }}>登出</span>
        </div>
      </aside>

      {/* 手機版底部導航 */}
      <nav
        className="fixed bottom-0 left-0 right-0 z-40 md:hidden"
        style={{
          height: '64px',
          background: 'var(--bg-surface)',
          borderTop: '1px solid var(--border)',
        }}
      >
        <div className="flex justify-around items-center h-full px-2">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className="flex flex-col items-center gap-1 py-2 px-3"
            >
              {({ isActive }) => (
                <>
                  <NavIcon type={item.icon} isActive={isActive} />
                  <span
                    className="text-xs"
                    style={{ color: isActive ? '#e91e8c' : '#8888aa' }}
                  >
                    {item.label}
                  </span>
                </>
              )}
            </NavLink>
          ))}
        </div>
      </nav>

      {/* 主內容區域 */}
      <main
        className="min-h-screen pb-20 md:pb-0"
        style={{ marginLeft: '0', paddingLeft: '72px' }}
      >
        {/* 頂部欄 */}
        <header
          className="sticky top-0 z-30 flex items-center justify-between px-6"
          style={{
            height: '56px',
            background: 'rgba(16, 16, 26, 0.8)',
            backdropFilter: 'blur(12px)',
            borderBottom: '1px solid var(--border)',
          }}
        >
          <h1 className="text-base font-medium text-text-primary">
            {getPageTitle(location.pathname)}
          </h1>

          <div className="flex items-center gap-4">
            {/* 系統狀態 */}
            <div className="flex items-center gap-2">
              <div
                className="w-2 h-2 rounded-full"
                style={{
                  background: '#00e676',
                  boxShadow: '0 0 8px #00e676',
                }}
              />
              <span className="text-xs text-text-secondary">系統正常</span>
            </div>

            {/* Feli 存在感圖標 */}
            <div className="relative">
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center cursor-pointer"
                style={{
                  background: 'linear-gradient(135deg, rgba(233, 30, 140, 0.2), rgba(233, 30, 140, 0.05))',
                }}
              >
                <div
                  className="w-4 h-4 rounded-full animate-breathe"
                  style={{
                    background: 'radial-gradient(circle at 30% 30%, #ff6bb3, #e91e8c)',
                    boxShadow: '0 0 10px rgba(233, 30, 140, 0.4)',
                  }}
                />
              </div>
              {/* 呼吸光環 */}
              <div
                className="absolute inset-0 rounded-full animate-ring-pulse"
                style={{
                  border: '1px solid rgba(233, 30, 140, 0.3)',
                }}
              />
            </div>
          </div>
        </header>

        {/* 頁面內容 */}
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
